module.exports = __webpack_public_path__ + "static/media/interface.abc6f0b2.png";